<app-dialog-header [title]="space ? 'Editar Espaço' : 'Adicionar Espaço'"></app-dialog-header>

<mat-dialog-content>
  <div class="container modal-space" id="modalSpace">
    <form [formGroup]="spaceForm" (ngSubmit)="saveSpace()">
      <div class="d-flex flex-column justify-content-between p-3">
        <div>
          <p class="h4 title">Informações do Espaço</p>
          <p class="p text-secondary">
            Forneça um nome claro e uma descrição atrativa. Defina a quantidade disponível, preço e consumação.
          </p>
        </div>

        <div class="row mt-3">
          <div class="col-12">
            <label for="spaceTitle" class="form-label">Título *</label>
            <input
              id="spaceTitle"
              formControlName="title"
              type="text"
              class="form-control"
              placeholder="Ex: Camarote VIP"
              [class.is-invalid]="spaceForm.controls.title.touched && spaceForm.controls.title.invalid" />
            @if (spaceForm.controls.title.touched && spaceForm.controls.title.hasError("required")) {
              <div class="invalid-feedback">Título é obrigatório.</div>
            }
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-12">
            <label for="spaceDescription" class="form-label">Descrição *</label>
            <textarea
              pTextarea
              id="spaceDescription"
              formControlName="description"
              rows="3"
              class="form-control"
              placeholder="Descreva o espaço para os compradores"
              [class.is-invalid]="
                spaceForm.controls.description.touched && spaceForm.controls.description.invalid
              "></textarea>
            @if (spaceForm.controls.description.touched && spaceForm.controls.description.hasError("required")) {
              <div class="invalid-feedback">Descrição é obrigatória.</div>
            }
          </div>
        </div>

        <div class="row mt-3 align-items-end">
          <div class="col-12 col-md-4">
            <div class="d-flex flex-column h-100">
              <label for="spaceQuantity" class="form-label">Quantidade de ingressos *</label>
              <input
                id="spaceQuantity"
                formControlName="quantity"
                type="number"
                min="1"
                step="1"
                class="form-control mt-auto"
                [class.is-invalid]="spaceForm.controls.quantity.touched && spaceForm.controls.quantity.invalid" />
              @if (spaceForm.controls.quantity.touched) {
                @if (spaceForm.controls.quantity.hasError("required")) {
                  <div class="invalid-feedback">Quantidade de ingressos é obrigatória.</div>
                }
                @if (spaceForm.controls.quantity.hasError("min")) {
                  <div class="invalid-feedback">Quantidade de ingressos deve ser maior que 0.</div>
                }
              }
            </div>
          </div>

          <div class="col-12 col-md-4">
            <div class="d-flex flex-column h-100">
              <label for="spacePrice" class="form-label">Valor do ingresso *</label>
              <div class="input-group mt-auto">
                <span class="input-group-text">R$</span>
                <input
                  id="spacePrice"
                  formControlName="price"
                  type="number"
                  class="form-control"
                  [class.is-invalid]="spaceForm.controls.price.touched && spaceForm.controls.price.invalid" />
              </div>
              @if (spaceForm.controls.price.touched) {
                @if (spaceForm.controls.price.hasError("required")) {
                  <div class="invalid-feedback d-block">Valor do ingresso é obrigatório.</div>
                }
                @if (spaceForm.controls.price.hasError("min")) {
                  <div class="invalid-feedback d-block">Valor do ingresso deve ser maior que ou igual a 1.</div>
                }
              }
            </div>
          </div>

          <div class="col-12 col-md-4">
            <div class="d-flex flex-column h-100">
              <label for="spaceConsumption" class="form-label">Valor da consumação *</label>
              <div class="input-group mt-auto">
                <span class="input-group-text">R$</span>
                <input
                  id="spaceConsumption"
                  formControlName="consumption"
                  type="number"
                  class="form-control"
                  [class.is-invalid]="
                    spaceForm.controls.consumption.touched && spaceForm.controls.consumption.invalid
                  " />
              </div>
              @if (spaceForm.controls.consumption.touched) {
                @if (spaceForm.controls.consumption.hasError("required")) {
                  <div class="invalid-feedback d-block">Valor da consumação é obrigatória.</div>
                }
                @if (spaceForm.controls.consumption.hasError("min")) {
                  <div class="invalid-feedback d-block">Valor da consumação deve ser maior ou igual a 0.</div>
                }
              }
            </div>
          </div>
        </div>

        <div class="d-flex flex-column align-items-end gap-1 mt-2" [title]="getTaxString()">
          <div class="d-flex gap-2">
            <span class="text-secondary">Taxa (10% sobre o valor do ingresso)</span>
            <p class="p text-secondary m-0">{{ getTaxValue() | currency: "BRL" }}</p>
          </div>
          <div class="d-flex gap-2">
            <span>Valor final</span>
            <p class="p text-success m-0">{{ getFinalPriceValue() | currency: "BRL" }}</p>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-12 col-md-6">
            <div class="form-grid">
              <label for="spaceSaleStart" class="form-label">Início da venda *</label>
              <p-datePicker
                appDatepickerMask
                id="spaceSaleStart"
                formControlName="saleStart"
                inputStyleClass="w-100"
                class="w-100"
                [showTime]="true"
                [hourFormat]="'24'"
                [showIcon]="true"
                [iconDisplay]="'input'"
                [selectOtherMonths]="true"
                [minDate]="space || ticketBatches.length > 0 ? null : dateNow"
                [class.ng-dirty]="spaceForm.controls.saleStart.dirty"
                [class.ng-invalid]="spaceForm.controls.saleStart.touched && spaceForm.controls.saleStart.invalid" />
              @if (spaceForm.controls.saleStart.touched && spaceForm.controls.saleStart.hasError("required")) {
                <div class="invalid-feedback">Data de início é obrigatória.</div>
              }
            </div>
          </div>

          <div class="col-12 col-md-6">
            <div class="form-grid">
              <label for="spaceSaleEnd" class="form-label">Fim da venda *</label>
              <p-datePicker
                appDatepickerMask
                id="spaceSaleEnd"
                formControlName="saleEnd"
                inputStyleClass="w-100"
                class="w-100"
                [showTime]="true"
                [hourFormat]="'24'"
                [showIcon]="true"
                [iconDisplay]="'input'"
                [selectOtherMonths]="true"
                [minDate]="space || ticketBatches.length > 0 ? null : dateNow"
                [class.ng-dirty]="spaceForm.controls.saleEnd.dirty"
                [class.ng-invalid]="spaceForm.controls.saleEnd.touched && spaceForm.controls.saleEnd.invalid" />
              @if (spaceForm.controls.saleEnd.touched && spaceForm.controls.saleEnd.hasError("required")) {
                <div class="invalid-feedback">Data de término é obrigatória.</div>
              }
            </div>
          </div>
        </div>

        @if (!space && ticketBatches.length > 0) {
          <div class="alert alert-info mt-3 d-flex align-items-center gap-2" role="alert">
            <i class="pi pi-info-circle"></i>
            As datas de venda foram preenchidas com base no início do primeiro lote e no fim do último lote atual.
          </div>
        }

        <!-- Group-level validation errors -->
        <div class="mt-2">
          @if (spaceForm.errors?.["saleEndBeforeStart"] && spaceForm.touched) {
            <div class="text-danger">A data de término da venda deve ser posterior à data de início.</div>
          }
        </div>
      </div>
    </form>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="gap-2">
  <app-button styleType="secondary" (click)="closeModal()">Cancelar</app-button>
  <app-button type="submit" (click)="saveSpace()">Salvar</app-button>
</mat-dialog-actions>
